import { Link } from 'react-router-dom';
import Button from 'app/shared-components/marketing/Button';
import { socialLinks } from '../../../main/marketing-v2/marketingNavigationConfig';

const footerNavigation = {
  solutions: [
    { title: 'For Providers', url: '/providers' },
    { title: 'For Patients', url: '/patients' },
    { title: 'Provider Directory', url: '/directory/providers' }
  ],
  product: [
    { title: 'Features', url: '/features' },
    { title: 'Security', url: '/security' },
    { title: 'Pricing', url: '/pricing' }
  ],
  resources: [
    { title: 'Blog', url: '/blog' },
    { title: 'Community Articles', url: '/community-articles' }
  ],
  company: [
    { title: 'About', url: '/about' },
    { title: 'Terms of Service', url: '/pages/terms' },
    { title: 'Privacy Policy', url: '/pages/privacy' }
  ]
};

function FooterLayoutMarketingV2() {
  return (
    <footer className="bg-hs-blue">
      <div className="container px-40 py-20 md:py-36 flex flex-col md:flex-row gap-y-8 md:justify-between md:gap-x-16 items-center md:items-start">
        <div className="hidden md:block">
          <Link
            to="/"
            className="block w-160"
          >
            <img
              src="assets/images/logo/HALESPRING-WHITE.png"
              className="w-full"
            />
          </Link>
        </div>

        <nav className="self-start -mt-16">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-x-12 gap-y-16">
            <div>
              <h3 className="text-white font-semibold text-14 uppercase mb-12">Solutions</h3>
              <ul className="space-y-8">
                {footerNavigation.solutions.map((item, index) => (
                  <li key={index}>
                    <Link
                      to={item.url}
                      className="text-white/80 hover:text-white font-medium text-14"
                    >
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            
            <div>
              <h3 className="text-white font-semibold text-14 uppercase mb-12">Product</h3>
              <ul className="space-y-8">
                {footerNavigation.product.map((item, index) => (
                  <li key={index}>
                    <Link
                      to={item.url}
                      className="text-white/80 hover:text-white font-medium text-14"
                    >
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            
            <div>
              <h3 className="text-white font-semibold text-14 uppercase mb-12">Resources</h3>
              <ul className="space-y-8">
                {footerNavigation.resources.map((item, index) => (
                  <li key={index}>
                    <Link
                      to={item.url}
                      className="text-white/80 hover:text-white font-medium text-14"
                    >
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            
            <div>
              <h3 className="text-white font-semibold text-14 uppercase mb-12">Company</h3>
              <ul className="space-y-8">
                {footerNavigation.company.map((item, index) => (
                  <li key={index}>
                    <Link
                      to={item.url}
                      className="text-white/80 hover:text-white font-medium text-14"
                    >
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </nav>

        <div className="flex flex-col items-center gap-y-8 order-first md:order-none">
          <ul className="flex gap-x-12">
            {socialLinks.map((item) => 
              <li key={item.id}>
                <a
                  href={item.url}
                  target={item.target}
                >
                  <img
                    src={`assets/images/social/${item.title.toLowerCase()}.svg`}
                    alt={item.title}
                    className="w-60 h-60"
                  />
                </a>
              </li>
            )}
          </ul>

          <a
            className="text-hs-green text-18 font-medium"
            href="mailto:info@halespring.com"
            target="_blank"
          >
            info@halespring.com
          </a>
        </div>

        <div className="hidden md:flex flex-col gap-y-12 w-200 -mt-2">
          <Button
            to="/sign-up"
            className="bg-hs-blue-light hover:bg-hs-blue-pale text-hs-blue"
            dense
          >
            Sign Up
          </Button>

          <Button
            to="/sign-in"
            className="bg-hs-blue hover:bg-hs-blue-dark text-hs-blue-light outline-hs-blue-light"
            dense
          >
            Log In
          </Button>
        </div>
      </div>

      <div className="bg-hs-blue-dark text-white text-16">
        <div className="container px-40 flex flex-col md:flex-row gap-y-8 md:justify-between items-center py-10 md:py-24">
          <div>
            ©{new Date().getFullYear()} Halespring Public Benefit Corporation. All rights reserved
          </div>
        </div>
      </div>
    </footer>
  );
}

export default FooterLayoutMarketingV2;